import leadActions from "../Actions/leadActions";
import DropDown from "../Components/DropDown";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux'
import customerActions from "../Actions/customerActions";
import CustomerDirectorytable from "../Components/CustomerDirectorytable";
import commonActions from "../Actions/commonActions";
import { withTranslation } from "react-i18next";
import { DefaultCard } from "../Components/Card/Card";

function CustomerDirectoryContainer({
    t,
    salesPersons,
    aoCustomers,
    leadActions,
    customerActions,
    commonActions,
}) {

    const [selectedSalesPersons, setSelectedSalesPersons] = useState(() => {
        try {
            return JSON.parse(localStorage.salesPersonsForCustomerDirectory || '[]');
        } catch {
            return [];
        }
    });

    useEffect(() => {
        leadActions.getAoSalesPersons();
        getAoCustomers();
    }, []);

    useEffect(() => {
        leadActions.getAoSalesPersons();
    }, [leadActions]);

    useEffect(() => {
        if (!selectedSalesPersons || selectedSalesPersons.length === 0) {
            customerActions.clearAoCustomers();
        } else {
            customerActions.getAoCustomers(selectedSalesPersons.map(sp => sp.salesNumber));
        }
        localStorage.salesPersonsForCustomerDirectory = JSON.stringify(selectedSalesPersons);
    }, [selectedSalesPersons, customerActions]);

    function addSalesPerson(salesPerson) {
        if (!selectedSalesPersons.some(sp => sp.salesNumber === salesPerson.salesNumber)) {
            setSelectedSalesPersons(prev => [...prev, salesPerson]);
        }
    }

    function onRemoveSalesPerson(salesPerson) {
        setSelectedSalesPersons(prev => prev.filter(sp => sp.salesNumber !== salesPerson.salesNumber));
    }

    function clearSelectedSalesPersons() {
        setSelectedSalesPersons([]);
    }

    function onSelect(salesPersonId) {
        const salesPerson = salesPersons.find(s => s.id === salesPersonId);
        if (salesPerson) {
            addSalesPerson(salesPerson);
        }
    }

    let notSelectedSalesPersons = [];

    if (salesPersons) {
        notSelectedSalesPersons = salesPersons.filter(s => !selectedSalesPersons.some(salesPerson => s.salesNumber === salesPerson.salesNumber));
        notSelectedSalesPersons = notSelectedSalesPersons.filter(s => s.salesNumber > 0);
    }

    const sortListByKey = (listName, list) => {
        return key => {
            commonActions.sortListByKey(list, key, listName);
        }
    }

    useEffect(() => {
        localStorage.salesPersonsForCustomerDirectory = JSON.stringify(selectedSalesPersons);
        getAoCustomers();
    }, [selectedSalesPersons])

    const getAoCustomers = () => {
        const salesPersons = localStorage.salesPersonsForCustomerDirectory ? JSON.parse(localStorage.salesPersonsForCustomerDirectory) : [];
        
        if (!salesPersons || salesPersons.length === 0) {
            return customerActions.clearAoCustomers();
        }
        customerActions.getAoCustomers(selectedSalesPersons.map((item, index) => {
            return item.salesNumber;
        }));
    }

    const renderSelectedSalesPersons = () => {
        return (
            <div className="address-button-container d-flex justify-content-end gap-8 flex-wrap">
                {selectedSalesPersons && selectedSalesPersons.length > 0 && selectedSalesPersons.map((selectedSalesPerson, index) => {
                    return <button key={index} className="btn btn-default btn-sm address-button"
                                   type="button">{selectedSalesPerson.name}<span
                        onClick={() => onRemoveSalesPerson(selectedSalesPerson)}
                        className="address-remove">&times;</span></button>
                })}
            </div>
        )
    }

    if (!salesPersons) {
        return null
    }

    return (
        <DefaultCard title={t('customerdirectorytable.customerdirectory')}>
            <div>
                {/* p-0 removes the grid column's 16px padding, which otherwise indents the
                    select 16px past the Remove all button below it. */}
                <DropDown list={notSelectedSalesPersons} onChange={onSelect} blankOption={true} value={-1} customClass="p-0"></DropDown>
                {selectedSalesPersons && selectedSalesPersons.length > 0 && <button className="btn btn-default btn-sm"
                                                                                    onClick={() => clearSelectedSalesPersons()}>{t('customerdirectorytable.removeall')}</button>}
            </div>
            {renderSelectedSalesPersons()}
            {aoCustomers && aoCustomers.length > 0 && <CustomerDirectorytable aoCustomers={aoCustomers}
                                                                              sortListByKey={sortListByKey("aoCustomers", aoCustomers)}/>}
        </DefaultCard>
    )
}
function mapStateToProps(state) {
    return {
        salesPersons: state.LeadsReducer.aoSalesPersons,
        aoCustomers: state.CustomerReducer.aoCustomers,
        user: state.CommonReducer.user
    }
}

function mapDispatchToProps(dispatch) {
    return {
        leadActions: bindActionCreators(leadActions, dispatch),
        customerActions: bindActionCreators(customerActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CustomerDirectoryContainer));